// spec-012-avaliacao-e-metricas-de-aprendizado ([T027], `contracts/
// ui-components.md` §7) — tela "Métricas da IA" (`view-metricas-ia.vue`),
// a tradução métrica → `BaseSummaryCard` (`utils/metricas-summary.js`) e a
// tabela de resultados (`components/eval-resultados-tabela/`).
//
// Vive em arquivo PRÓPRIO — `Text.js` já estava no teto de 500 linhas
// (CLAUDE.md do monorepo: arquivos ≤500 linhas, quebrar por responsabilidade
// ao crescer). `Text.js` reexporta cada export daqui — mesmo padrão de
// `MEMORIA_TEXT`/`Text.memoria.js` (spec-002 [T016]) e `Text.aprendizado.js`
// (spec-007 [T021]).
//
// Textos literais vieram do contrato (§7) — não invente copy nova sem
// conferir o documento. Onde o contrato não dá o texto literal (mensagens de
// estado vazio/erro por seção, rótulos auxiliares), a copy segue o registro
// da casa (frases curtas, sempre com a solução/próximo passo).

// ─── §7 do contrato — texto literal ─────────────────────────────────────
export const METRICAS_TEXT = {
  titulo: 'Métricas da IA',
  subtitulo: 'O que a IA aprendeu, quanto custou e o que a avaliação reprovou.',
  vazio: 'Ainda não há dados no período. As métricas aparecem depois que a IA for usada no escritório.',
  erroSecao: 'Não foi possível calcular esta seção agora.',
  naoInstrumentado: 'não instrumentado',
  amostraPequena: (n) => `amostra pequena (n=${n})`,
  semDados: 'sem dados no período',
  // Complementares — não estão no §7 literal, mas seguem o mesmo registro
  // (frase curta + próxima ação), usados pela view/`FeedbackWrapper`.
  proibido: 'Esta área está disponível apenas para gestores do escritório.',
  erroPainel: 'Não foi possível carregar as métricas agora. Tente novamente mais tarde.',
  retry: 'Tentar de novo',
  atualizar: 'Atualizar',
  semResultados: 'Nenhuma avaliação registrada neste período.',
  erroResultados: 'Não foi possível carregar os resultados de avaliação agora.',
}

// ─── §7 do contrato — as 3 seções (BaseSegmentedTabs, `secaoAtiva`) ────────
export const SECOES_METRICAS = [
  { chave: 'aprendizado', label: 'Aprendizado' },
  { chave: 'agentes', label: 'Agentes e custo' },
  { chave: 'evals', label: 'Evals e publicações' },
]

// ─── `_eval_resultados.status` (`evals/resultados.py::STATUS_VALIDOS`) ────
export const STATUS_EVAL_LABELS = {
  verde: 'Aprovada',
  vermelho: 'Reprovada',
  pendente: 'Aguardando',
}

// Cor por status — molde de `RISCO_COLORS` (`Text.aprendizado.js`), usado
// pelo `BaseStatus` de `eval-resultados-tabela.vue` (prop `content`, nunca
// `value` — §4 do contrato).
export const STATUS_EVAL_CORES = {
  verde: 'success',
  vermelho: 'danger',
  pendente: 'warning',
}

// ─── `_eval_resultados.alvo_tipo` / `Dataset.alvo` (`evals/resultados.py`,
// `evals/datasets/registro.py::ALVOS_VALIDOS`) ─────────────────────────────
export const ALVO_LABELS = {
  agente_versao: 'Versão de agente',
  skill: 'Skill',
  memoria: 'Memória',
  advisory: 'Comitê',
  roteador: 'Roteador',
}

// ─── seletor de período do painel (`GET /evals/painel?periodo=`) — os 3
// valores aceitos por `resource_evals_painel.py::PERIODOS_VALIDOS` ─────────
export const METRICAS_PERIODO_OPTIONS = [
  { text: '7 dias', value: '7d' },
  { text: '30 dias', value: '30d' },
  { text: '90 dias', value: '90d' },
]
